/**
 * Method for converting number with currency code into string with currency symbol
 * @param {string} currencyCode - Code of currency
 * @param {number} value - Value
 */
const convertToCurrencyLocaleString = (
  currencyCode: string,
  value: number,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  try {
    return value.toLocaleString('en', {
      minimumFractionDigits,
      maximumFractionDigits,
      style: 'currency',
      currency: currencyCode
    })
  } catch (err) {
    /**
     * NOTE: toLocaleString will throw error in case currencyCode passed is in  valid or something it does not understand,
     * we will return value with currency code string in such cases
     */
    return currencyCode ? `${value} ${currencyCode}` : `${value}`
  }
}

export { convertToCurrencyLocaleString }
